"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetEndpoint = exports.Endpoints = void 0;
function reverseEnum(e) {
    const ret = {};
    Object.keys(e).forEach((k) => ret[e[k]] = k);
    return ret;
}
function twoWayEnum(e) {
    return Object.assign(reverseEnum(e), e);
}
var Endpoints;
(function (Endpoints) {
    // Default outgoing endpoint name.
    Endpoints["Tx"] = "tx";
    // Default incoming endpoint name.
    Endpoints["Rx"] = "rx";
    // Command endpoint name. Used on some Kiiroo devices.
    Endpoints["Command"] = "command";
    // Generic name for devices that have a firmware loading endpoint.
    Endpoints["Firmware"] = "firmware";
    Endpoints["TxMode"] = "txmode";
    Endpoints["TxVibrate"] = "txvibrate";
    Endpoints["TxShock"] = "txshock";
    Endpoints["TxVendorControl"] = "txvendorcontrol";
    Endpoints["RxTouch"] = "rxtouch";
    Endpoints["RxAccel"] = "rxaccel";
    Endpoints["Whitelist"] = "whitelist";
})(Endpoints = exports.Endpoints || (exports.Endpoints = {}));
const TwoWayEndpointsEnum = twoWayEnum(Endpoints);
function GetEndpoint(aStrEndpoint) {
    try {
        return TwoWayEndpointsEnum[aStrEndpoint];
    }
    catch (_a) {
        return null;
    }
}
exports.GetEndpoint = GetEndpoint;
//# sourceMappingURL=Endpoints.js.map